$(document).ready(function() {
  $('body').on('click', '#show-popup-setting-otp-off', function() {
    const message = "「二段階認証設定」は、アカポンへのログイン時に <br>ご登録のメールアドレス宛てに認証コードを送付し、<br>二段階認証を行うセキュリティ機能です。<br><br><strong>現在、二段階認証は 設定 の状態です。</strong>";
    Popup.confirm(message, {
      confirmText: '解除する',
      cancelBtn: false,
      classPopup: 'popup-seting-token',
      closeOnOverlay: true,
      success: () => { 
        Shared.callAjax(Routes.owner_turn_off_2fa_path(), {}, 'json')
        .done(function(data){
          $('#btn-show-off-otp-token').trigger('click');
        })
      },
    })
  })
  
  $('body').on('click', '#show-popup-setting-otp-on', function() {
    const message = "「二段階認証設定」は、アカポンへのログイン時に <br>ご登録のメールアドレス宛てに認証コードを送付し、<br>二段階認証を行うセキュリティ機能です。<br><br><strong>現在、二段階認証は OFF の状態です。</strong>";
    Popup.confirm(message, {
      confirmText: '設定する',
      cancelBtn: false,
      classPopup: 'popup-seting-token',
      closeOnOverlay: true,
      success: () => { 
        Shared.callAjax(Routes.owner_send_mail_setting_token_path(), { num_of_auth: 'first' }, 'json')
        .done(function(data){
          Popup.alert('ただ今、ご登録のメールアドレス宛に認証コードを送信しました。')
        })
      },
    })
  })
})
